import ReactGA from "react-ga4";
import {
  shopId,
  GA_UTM_SOURCE,
  GA_UTM_MEDIUM,
  GA_UTM_CAMPAIGN,
  GA_UTM_TERM,
  GA_UTM_ID,
  GA_CATEGORY,
} from "config/const";

export const setGAInLocalstorage = ({
  ga_utm_source,
  ga_utm_medium,
  ga_utm_campaign,
  ga_utm_term,
  ga_utm_id,
}) => {
  console.log(
    "ga_utm_source:" + ga_utm_source,
    "ga_utm_medium:" + ga_utm_medium,
    "ga_utm_campaign:" + ga_utm_campaign,
    "ga_utm_term:" + ga_utm_term,
    "ga_utm_id:" + ga_utm_id
  );

  localStorage.setItem(GA_UTM_SOURCE, ga_utm_source);
  localStorage.setItem(GA_UTM_MEDIUM, ga_utm_medium);
  localStorage.setItem(GA_UTM_CAMPAIGN, ga_utm_campaign);
  localStorage.setItem(GA_UTM_TERM, ga_utm_term);
  localStorage.setItem(GA_UTM_ID, ga_utm_id);
};

export const GaEventType = {
  REDEEM: "redeem",
  SUBMIT: "formSubmit",
  EXPLORE: "explore",
  SEND_SMS: "sendSms",
  VERIFY_PHONE: "verifyPhone",
  SUBMITED: "formSubmited",
  BUY_IMMEDIATELY: "buyImmediately",
  EXPERIENCE: "experience",
};

export const sendGAEvent = (lineId, action, others = {}) => {
  if (!lineId || !action) return;
  console.log(action);
  const event = {
    userId: `shop/${shopId}/user/${lineId}`,
    category: `${GA_CATEGORY}/${shopId}`,
    title: action,
    action,
    label: `shop/${shopId}/customer/${lineId}/campaign/${localStorage.getItem(
      GA_UTM_CAMPAIGN
    )}/source/${localStorage.getItem(
      GA_UTM_SOURCE
    )}/medium/${localStorage.getItem(
      GA_UTM_MEDIUM
    )}/term/${localStorage.getItem(GA_UTM_TERM)}/id/${localStorage.getItem(
      GA_UTM_ID
    )}`,
    value: 1,
    ...others,
  };
  ReactGA.event({ ...event, shopId, lineId });
};

export const sendGATagEvent = (lineId, action) => {
  if (!lineId || !action) return;

  ReactGA.set({
    userId: `shop/${shopId}/user/${lineId}`,
    referrer: `https://linebot/shop/${shopId}/user/${lineId}`,
    title: "/tag",
  });
  const event = {
    category: `${GA_CATEGORY}/tag/${shopId}`,
    action,
    label: `shop/${shopId}/customer/${lineId}/campaign/${localStorage.getItem(
      GA_UTM_CAMPAIGN
    )}/source/${localStorage.getItem(
      GA_UTM_SOURCE
    )}/medium/${localStorage.getItem(
      GA_UTM_MEDIUM
    )}/term/${localStorage.getItem(GA_UTM_TERM)}/id/${localStorage.getItem(
      GA_UTM_ID
    )}`,
    value: 1,
  };
  ReactGA.event(event);
};

export function finishFormTrack() {
  if (window.gtag) {
    console.log("gtag:conversion");
    window.gtag("event", "conversion", {
      send_to: "AW-10971568925/bFSTCKWBgdgDEJ220-8o",
    });
  }
}

export const ButtonType = {
  BUY: "即刻體驗",
  EXPERIENCE: "即刻體驗",
  EXPLORE: "即刻選購",
  SUBMIT: "確認送出",
  REDEEM: "確認兌換",
  SUBMITED: "探索更多",
};

export function gtmButtonClick(buttonType) {
  if (window.gtag) {
    console.log("gtag:", {
      event_category: "Button",
      event_action: "Click",
      event_label: buttonType,
      value: 1,
    });
    window.gtag("event", "conversion", {
      event_category: "Button",
      event_action: "Click",
      event_label: buttonType,
      value: 1,
    });
  }
}
